<div class="custom-modal novo-produto">
  <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 170px">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
  </div>
  <perfect-scrollbar [autoPropagation]="true">
    <div class="m-2">
      <form [formGroup]="formCadastro" autocomplete="off">
        <mat-tab-group [selectedIndex]="btnNextPrev.index" dynamicHeight="true">
          <mat-tab *ngFor="let item of itensMenu.menu; index as i">
            <div>
              <ng-template mat-tab-label>
                <span [ngClass]="item.concluido(formCadastro) ? 'numberCircleSelected':'numberCircle'">
                  {{ (i+1) }}</span>
                {{item.label}}
              </ng-template>
              <mat-card>
                <mat-card-content>
                  <ndc-dynamic [ngComponentOutlet]="item.component" [ndcDynamicInputs]="item.inputs"
                    [ndcDynamicOutputs]="item.outputs"></ndc-dynamic>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>
        </mat-tab-group>
      </form>
    </div>
  </perfect-scrollbar>
</div>
